import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  withStyles, MenuItem, Chip, IconButton, Icon, TextField,
} from '@material-ui/core';
import FilterWrapper from '../filter-wrapper/filter-wrapper';


import { ListSelector } from '../../../components';
import { comparisonOptionNames } from '../../../models';

export const multiLocationFilterName = 'MultiLocationFilter';

const styles = {
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  select: {
    width: '100%',
    marginBottom: '10px',
  },
  header: {
    margin: '10px',
    wordBreak: 'break-word',
  },
  menuItemRoot: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  searchBar: {
    width: '100%',
    padding: '16px',
  },
  iconButon: {
    padding: 0,
  },
};

class MultiLocationFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
      isOpen: false,
    };
  }

  renderSelectedValues = (selectedValues) => {
    const { locations } = this.props;

    if (!selectedValues || selectedValues.length === 0 || locations.length === 0) {
      return <div>-</div>;
    }

    return (
      <div className={styles.chips}>
        {selectedValues.map((value) => {
          const location = locations.find(l => l.id === value);
          return (
            <Chip
              key={value}
              label={location ? location.name : value}
              style={{ margin: '3px ' }}
            />
          );
        })}
      </div>
    );
  };

  getNextComparisonId = () => {
    const { comparisonDateRanges } = this.props;

    const { length } = comparisonDateRanges.filter(cdr => cdr.option !== comparisonOptionNames.none);
    return length === 0 ? 1 : comparisonDateRanges[length - 1].comparisonId + 1;
  }

  handleSelect = (locationId) => {
    const {
      selectLocation, removeReportData, comparisonDateRanges, setComparisonDateRange, selectedLocation,
    } = this.props;

    const comparisonDateRange = comparisonDateRanges.find(cdr => cdr.locationId === locationId);

    if (comparisonDateRange) {
      removeReportData(comparisonDateRange.comparisonId);
      setComparisonDateRange({
        comparisonId: comparisonDateRange.comparisonId,
        option: comparisonOptionNames.identical,
        locationId: selectedLocation.id,
      });
    }

    removeReportData(0);
    selectLocation(locationId);
    this.setState({ isOpen: false });
  }

  handleAdd = (e, locationId) => {
    const { setComparisonDateRange } = this.props;

    e.stopPropagation();
    setComparisonDateRange({
      comparisonId: this.getNextComparisonId(),
      option: comparisonOptionNames.identical,
      locationId,
    });
  }

  handleRemove = (e, locationId) => {
    const { removeComparisonDateRange, removeReportData, comparisonDateRanges } = this.props;
    e.stopPropagation();

    const comparisonDateRangeToRemove = comparisonDateRanges.find(cdr => cdr.locationId === locationId);
    removeComparisonDateRange(comparisonDateRangeToRemove.comparisonId);
    removeReportData(comparisonDateRangeToRemove.comparisonId);
  }

  filterByTerm = (item) => {
    const { searchTerm } = this.state;
    const searchLowerCase = searchTerm.toLowerCase();

    return String(item.name).toLowerCase().includes(searchLowerCase);
  }

  reset = () => {
    const { comparisonDateRanges, removeComparisonDateRange, removeReportData } = this.props;

    comparisonDateRanges.forEach((cdr) => {
      removeComparisonDateRange(cdr.comparisonId);
      removeReportData(cdr.comparisonId);
    });
  }

  renderSearch = () => {
    const { searchTerm } = this.state;

    return (
      <TextField
        autoFocus
        placeholder="Suche"
        value={searchTerm}
        onChange={e => this.setState({ searchTerm: e.target.value })}
        style={styles.searchBar}
      />
    );
  }

  render() {
    const {
      locations, comparisonDateRanges, selectedLocation, classes,
    } = this.props;
    const { searchTerm, isOpen } = this.state;

    if (!selectedLocation) {
      return null;
    }

    if (locations && locations.length === 1) {
      return <h2 style={styles.header}>{locations[0].name}</h2>;
    }

    const selectedLocations = [selectedLocation.id]
      .concat(comparisonDateRanges.filter(cdr => cdr.option !== comparisonOptionNames.none).map(cdr => cdr.locationId))
      .filter(id => id !== -1);

    let locationsForThisReport = locations.filter(l => l.id !== selectedLocation.id);

    if (locationsForThisReport.length < 1) {
      return null;
    }

    if (searchTerm) {
      locationsForThisReport = locationsForThisReport.filter(this.filterByTerm);
    }


    const selectedLocationItem = (
      <MenuItem key={selectedLocation.id} value={selectedLocation.id} selected>
        {selectedLocation.name}
      </MenuItem>
    );

    const locationItems = locationsForThisReport.map(a => (
      <MenuItem key={a.id} value={a.id} classes={{ root: classes.menuItemRoot }} onClick={() => this.handleSelect(a.id)}>
        {a.name}
        {selectedLocations.includes(a.id) ? (
          <IconButton style={styles.iconButon} onClick={e => this.handleRemove(e, a.id)}>
            <Icon>remove</Icon>
          </IconButton>
        ) : (
          <IconButton style={styles.iconButon} onClick={e => this.handleAdd(e, a.id)}>
            <Icon>add</Icon>
          </IconButton>
        )}
      </MenuItem>
    ));


    return (
      <FilterWrapper
        title="Lokale"        
        resetFilter={this.reset}
        isResetDisabled={selectedLocations.length <= 1}
      >
        <ListSelector
          selectedItems={selectedLocations}
          style={styles.select}
          renderValue={this.renderSelectedValues}
          listOpen={isOpen}
          toggleOpen={open => this.setState({ isOpen: open })}
        >
          {this.renderSearch()}
          {selectedLocationItem}
          {locationItems}
        </ListSelector>
      </FilterWrapper>

    );
  }
}

MultiLocationFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  selectedLocation: PropTypes.object,
  comparisonDateRanges: PropTypes.array.isRequired,
  setComparisonDateRange: PropTypes.func.isRequired,
  removeComparisonDateRange: PropTypes.func.isRequired,
  removeReportData: PropTypes.func.isRequired,
  selectLocation: PropTypes.func.isRequired,
};

MultiLocationFilter.defaultProps = {  
  selectedLocation: null,
};

export default withStyles(styles)(MultiLocationFilter);
